export const manifest = {
  screens: {
    scr_mgq43d: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_nrhesi: { name: "Jobs", route: "/jobs", position: {"x":1560,"y":220} },
    scr_nm82aj: { name: "Monthly Budget Allocations", route: "/jobs", state: {"activeTab":"budget"}, position: {"x":160,"y":2200} },
    scr_f2fw6b: { name: "Invoices", route: "/invoices", position: {"x":160,"y":4180} },
    scr_4fz649: { name: "Settings", route: "/settings", position: {"x":160,"y":6160} },
    scr_2uphhk: { name: "Time Sheets", route: "/timesheets", position: {"x":160,"y":8140} },
    scr_zozfsn: { name: "Account", route: "/account", position: {"x":160,"y":10120} },
  },
  sections: {
    sec_kmobh5: { name: "Primary Navigation", x: 0, y: 0, width: 2920, height: 1180 },
    sec_x577le: { name: "Budget Management", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_9mns5w: { name: "Invoices Management", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_0o2j2d: { name: "Settings", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_njaset: { name: "Time Tracking", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_is9nht: { name: "Account Management", x: 0, y: 9900, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_kmobh5", children: [
      { kind: "screen", id: "scr_mgq43d" },
      { kind: "screen", id: "scr_nrhesi" },
    ] },
    { kind: "section", id: "sec_x577le", children: [
      { kind: "screen", id: "scr_nm82aj" },
    ] },
    { kind: "section", id: "sec_9mns5w", children: [
      { kind: "screen", id: "scr_f2fw6b" },
    ] },
    { kind: "section", id: "sec_0o2j2d", children: [
      { kind: "screen", id: "scr_4fz649" },
    ] },
    { kind: "section", id: "sec_njaset", children: [
      { kind: "screen", id: "scr_2uphhk" },
    ] },
    { kind: "section", id: "sec_is9nht", children: [
      { kind: "screen", id: "scr_zozfsn" },
    ] },
  ],
}
